<template>
  <!-- 对话框 -->
  <el-dialog  :visible.sync="show" :before-close="closeDialog" width="90%">

    <el-form label-width="80px">

      <el-form-item label="主账号:" label-width='130px'>
        <el-input v-model="consumer_phone" placeholder="请输入老板电话" maxlength="11" style="width: 160px;">
        </el-input>
        <el-button style="margin-left: 10px;" type="primary" @click="editSubmit">修改</el-button>
        <el-button style="margin-left: 10px;" @click="addDialog_show = !addDialog_show">添加成员</el-button>
      </el-form-item>

    </el-form>

      <!-- 表格 -->
      <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand"
                        >f

                        <div class="more-style">
                            <el-form-item label="紧急联系人姓名:">
                                <span>{{ props.row.urgent_name }}</span>
                            </el-form-item>
                            <el-form-item label="紧急联系人电话:">
                                <span>{{ props.row.urgent_phone }}</span>
                            </el-form-item>
                            <el-form-item label="注册渠道:">
                                <span>{{ props.row.reg_from.alias }}</span>
                            </el-form-item>
                        </div>
                        <div class="more-style">
                            <el-form-item label="平台:">
                                <span>{{ props.row.platform.alias }}</span>
                            </el-form-item>
                            <el-form-item label="APP版本:">
                                <span>{{ props.row.app_version }}</span>
                            </el-form-item>
                            <el-form-item label="极光编码:">
                                <span>{{ props.row.registration_id }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="注册时间:">
                                <span>{{ props.row.reg_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="注册详细时间:">
                                <span>{{ props.row.reg_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="上次编辑时间:">
                                <span>{{ props.row.edit_time.Ymd }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="上次编辑详细时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="最后订单时间:">
                                <span>{{ props.row.last_order_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="最后订单详细时间:">
                                <span>{{ props.row.last_order_time.YmdHis }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="所在城市:">
                                <span>{{ props.row.city.name }}</span>
                            </el-form-item>

                            <el-form-item label="身份证号码:">
                                <span>{{ props.row.id_card }}</span>
                            </el-form-item>

                            <el-form-item label="车牌号码:">
                                <span>{{ props.row.car_number }}</span>
                            </el-form-item>
                        </div>

                        <el-form-item label="备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="id" label="id" width="80"> </el-table-column>

            <el-table-column prop="name" label="客户名称" min-width="150">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>客户唯一编码: {{ scope.row.consumer_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">{{ scope.row.name }}</el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="phone" label="手机电话" min-width="150"> </el-table-column>

            <el-table-column prop="city.name" label="所属城市" min-width="150"> </el-table-column>

            <el-table-column prop="last_order_time.YmdHis" label="最后一次下单时间" min-width="150"> </el-table-column>

            <el-table-column prop="order_num" label="已完成订单数量" min-width="150"> </el-table-column>

            <el-table-column prop="balance" label="余额">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)"> {{ scope.row.total_balance }}元 </span>
                </template>
            </el-table-column>

            <el-table-column label="性别">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.sex.val == '0' ? 'danger' : scope.row.sex.val == '1' ? '' : 'warning'">
                        {{ scope.row.sex.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="用户级别">
                <template slot-scope="scope">
                    <el-tag :type="Number(scope.row.total_balance) > 0 ? 'success' : ''">
                        {{ Number(scope.row.total_balance) > 0 ? 'vip用户' : '普通用户' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="管理状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="用户类型">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.last_order_time.YmdHis == '未设置' ? 'warning' : ''">
                        {{ scope.row.last_order_time.YmdHis == '未设置' ? '新用户' : '老用户' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="danger" @click="delConsumer(scope.row.consumer_code)">删除</el-button>
              </template>

            </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div style="text-align: right">
          <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function"> </el-pagination>
      </div>

      <div style="display: flex; justify-content: center">


          <el-button @click="closeDialog">关闭</el-button>
      </div>



       <!--  集团成员  -->
    <addDialog
            :data="search_data_children.group_wallet_code"
            :isShow="addDialog_show"
            @onSubmit="consumerLists('init')"
    ></addDialog>
  </el-dialog>
</template>

<script>
var _this;
import addDialog from './addDialog.vue';
export default {
  components: {
    addDialog
  },
  props: {
      isShow: Boolean,
      data: '',
  },
  watch: {
      isShow(newData, oldData) {
          _this.show = true;

          this.search_data_children.group_wallet_code = this.data.group_wallet_code;
          // 获取主账号信息
          this.$post(
            '/group/getGroupWalletDetails', {
              group_wallet_code: this.data.group_wallet_code
            }
          )
          .then(res => {

            this.consumer_phone = res.data.consumer_phone

          }).catch((err) => {

          })

          console.log(_this.data);

          _this.consumerLists();
      }
  },
  data() {
      return {


          show: false,

          addDialog_show:false,

          progress_show: false,

          consumer_phone:'',

          excelData: [],

          excelHead: [],

          tableData: [],

          //翻页数据
          search_data_children: {
              page: 1,
              limit: 10,
              group_wallet_code: ''
          },

          result_data_children: [],
          search_rules_children: {
              page: {
                  placeholder: '页码',
                  rules: {
                      required: true,
                      message: '页码需要大于0',
                      regulation: 'gt',
                      rulesData: 0
                  }
              },
              limit: {
                  placeholder: '每页个数',
                  rules: {
                      required: true,
                      message: '每页个数需在1-51之内',
                      regulation: 'between',
                      rulesData: [1, 51]
                  }
              }
          }
      };
  },
  created() {
      _this = this;
  },
  methods: {
    delConsumer(code){
      this.$post(
            '/consumer/editConsumerSubmit',
            {
              consumer_code:code,
              group_wallet_code:'',
              clear_field:this.search_data_children.group_wallet_code
            }
          )
          .then(res => {



            this.$message.success('删除成功');
            this.consumerLists()

          }).catch((err) => {

          })
    },
    editSubmit(){
      this.$post(
            '/group/editGroupWallet',
            {
              consumer_phone:_this.consumer_phone,
              group_wallet_code:this.search_data_children.group_wallet_code
            }
          )
          .then(res => {



            _this.$message.success('更改成功');

            _this.$emit('onSubmit');

          }).catch((err) => {

          })
    },


      // 获取钱包信息
      consumerLists(val) {
        if(val == 'init'){
          this.search_data_children.page = 1;
        }
          _this
              .$post('/consumer/consumerLists', _this.search_data_children, _this.search_rules_children)
              .then((res) => {
                  // 将获取到的数据赋值

                  _this.tableData = res.data;
                  console.log(res.data.result,'res.data.result');


                  _this.result_data_children = res;
                  console.log(res.data);
              })
              .catch((err) => {});
      },
      // 关闭方法
      closeDialog() {
          _this.show = false;
          _this.tableData = [];
          _this.result_data_children=[];
      },

      //翻页组件的回调
      pages_function(val) {
          _this.search_data_children.page = val;

          //初始化列表
          _this.consumerLists();
      }
  }
};
</script>

<style scoped>
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}
</style>
